import { defineMessages } from "react-intl";

export const rrMessages = defineMessages({
  following: {
    id: "rrMessages.following",
    defaultMessage: "Following",
  },
  recent: {
    id: "rrMessages.recent",
    defaultMessage: "Recent",
  },
  drafts: {
    id: "rrMessages.drafts",
    defaultMessage: "Drafts",
  },
  newReport: {
    id: "rrMessages.newReport",
    defaultMessage: "new report",
  },
  featured: {
    id: "rrMessages.featured",
    defaultMessage: "Featured",
  },
  moreStories: {
    id: "rrMessages.moreStories",
    defaultMessage: "More stories from",
  },
  contestEntries: {
    id: "rrMessages.contestEntries",
    defaultMessage: "Contest Entries",
  },
  theJournal: {
    id: "rrMessages.theJournal",
    defaultMessage: "the Journal",
  },
  news: {
    id: "rrMessages.news",
    defaultMessage: "News",
  },
  ridesIn: {
    id: "rrMessages.ridesIn",
    defaultMessage: "{number} rides in {timePeriod}",
    description: "A descriptive title, for example: 2 rides in April and March",
  },
  loadingReport: {
    id: "rrMessages.loadingReport",
    defaultMessage: "Loading report...",
  },
  loadingRideData: {
    id: "rrMessages.loadingRideData",
    defaultMessage: "Loading ride data...",
  },
  loadingMap: {
    id: "rrMessages.loadingMap",
    defaultMessage: "Loading map...",
  },
  editing: {
    id: "rrMessages.editing",
    defaultMessage: "Editing",
  },
  reportsBy: {
    id: "rrMessages.reportsBy",
    defaultMessage: "Reports by {name}",
  },
  yourReports: {
    id: "rrMessages.yourReports",
    defaultMessage: "Your Reports",
  },
  published: {
    id: "rrMessages.published",
    defaultMessage: "Published",
  },
});
